import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import './assets/css/icon.css';
import './components/common/directives';
import 'babel-polyfill';
import pagination from '@/components/common/pagination'
Vue.config.productionTip = false;
import { put, get, post, del } from '@/utils/request.js';
Vue.component('pagination', pagination)
Vue.prototype.$put = put;
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$del = del;
import  {formatOrdertime,data_detail_status_list,client_user_status_list,newDate,parseParmStr}  from '@/api/function.js';
Vue.prototype.$formatOrdertime = formatOrdertime;
Vue.prototype.$data_detail_status_list = data_detail_status_list;
Vue.prototype.$client_user_status_list = client_user_status_list;
Vue.prototype.$newDate = newDate;
Vue.prototype.$parseParmStr = parseParmStr;


// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts



// Vue.use(VueI18n);
Vue.use(ElementUI, {
    size: 'small'
});
// const i18n = new VueI18n({
//     locale: 'zh',
//     messages
// });
import * as filters from './filters'
// 注册全局过滤器
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

new Vue({
    router,
    store,
   
    render: (h) => h(App)
}).$mount('#app');
// i18n,
